import IFrame from '../../../../../Shared/IFrame';

/**
 *
 * @param {String} url : IFrame source URL
 * @returns IFrame with a survey
 */
const ContentQualtricsSurvey = ({ url }) => (
  <IFrame
    src={url}
    data-test-id='qualtrics-survey'
    title='Content Qualtrics Survey'
    style={{ height: '80vh' }}
  />
);

export default ContentQualtricsSurvey;
